'use client';

import { ProjectModel } from "@/lib/models/Project";
import { RouterName } from "@/lib/enum/RouterEnum";
import { useIsSafari } from '@/lib/hooks/useIsSafari';
import { useContentSize } from "@/components/SizeProvider";
import { clearNavState, setNavState } from "@/lib/utils/navState";
import { PAGE_MOBILE } from "@/lib/constants";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useLenis } from "lenis/react";

interface Props {
  listProject: ProjectModel[];
  idActive: number;
}

export default function ListProject(props: Props) {
  const { listProject, idActive } = props;
  const isSafari = useIsSafari();
  const classNameText = isSafari ? 'text-gray-safari' : 'text-gray';
  const { width: widthContent } = useContentSize();
  const pathname = usePathname();
  const isExperimentsHighlighted = pathname === '/' || pathname.startsWith('/project-detail');
  const lenis = useLenis();

  // Reset scroll on click too, so re-selecting the route you're already on
  // (where the pathname doesn't change) still snaps back to the top.
  const scrollToTop = () => {
    lenis?.scrollTo(0, { immediate: true });
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
  };

  return (
    <div className={'menu-wrapper'}>
      <p className={classNameText}>{"\\\\MENU\\\\"}</p>
      <Link
        href={RouterName.dashboard}
        onClick={() => { clearNavState(); scrollToTop(); }}
        className={`title-experiments ${isExperimentsHighlighted ? 'title-experiments-active' : ''}`}
        style={{ fontSize: widthContent / 160 }}
      >
        <h2>EXPERIMENTS <span className="experiments-view-all">[VIEW ALL]</span></h2>
      </Link>
      <ol className={'project-list'}>
        {listProject.map((item, index: number) => {
          return (
            <li
              className={`project-title ${idActive === item.id ? 'project-title-active' : ''}`}
              key={item.id}
            >
              <Link
                href={`${RouterName.projectDetail}/${item.slug}`}
                onClick={() => { setNavState(index + PAGE_MOBILE.PROJECTS); scrollToTop(); }}
                prefetch={false}
              >
                {`${(index + 1).toString().padStart(2, '0')}`}\{item.projectTitle.replaceAll(' ', '_')}
              </Link>
            </li>
          )
        })}
      </ol>
      <p className={isSafari ? "text-gray-safari2" : 'text-gray'}>{"<>"}</p>
    </div>
  )
};
